import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Row as VdsRow } from '@vds/grids';
import { ButtonIcon } from '@vds/button-icons';
import { Icon } from '@vds/icons';

import { Body, Micro, Title } from '../../../Typography';
import { viewport, isMobile, isTablet, getLTEUpgrade, isWHW, isMVA } from '../../../Helpers/index';
import { getProductRefData } from '../../../../../utils/plansReference';

const Row = styled(VdsRow)`
  margin-left: 0px;
  margin-right: 0px;
`;

const MiniCartHeading = styled.div`
  text-align: left;
  padding: ${isMobile || isTablet ? '4px 0 0 ' : '0'};
`;

const CommonSection = ({
  toggleCart,
  isCartVisible,
  leftValueText,
  rightValueText,
  subTitle,
  id,
  ariaLabelRight,
  ariaLabelLeft,
  showIcon,
  className = 'normalStyle',
  promoDiscount = false,
}) => {
  const type = viewport();
  const isMobileview = !!isMobile();

  const handleKeyDown = (event) => {
    if (event.key === 'Escape' && isCartVisible) {
      event.preventDefault();
      toggleCart(!isCartVisible);
    }
  };

  const handleClick = () => {
    toggleCart(!isCartVisible);
  };

  const TagName = className === 'headerStyle' ? Title : type === 'mobile' && type === 'mfapp' && className === 'normalStyle' ? Micro : Body;
  const spacingStyle =
    className === 'headerStyle'
      ? type !== 'mobile' && type !== 'mfapp'
        ? 'pad24'
        : 'pad16'
      : type !== 'mobile' && type !== 'mfapp'
        ? 'pad20'
        : 'pad12';
  const primitiveHeaderSize = className === 'headerStyle' ? 'h3' : 'p';
  return (
    <div id={id}>
      <Row className="justify-space-between">
        <div className={`${spacingStyle} onlyBottomPad width60`}>
          <MiniCartHeading aria-label={ariaLabelLeft}>
            <TagName
              primitive={primitiveHeaderSize}
              size={className === 'headerStyle' ? 'small' : type !== 'mobile' && type !== 'mfapp' && className === 'normalStyle' ? 'large' : 'small'}
            >
              {leftValueText}
            </TagName>
          </MiniCartHeading>
          {!isWHW() && subTitle !== '' && subTitle !== null ? (
            <div className="textAlignLeft">
              <Micro size="large" color="#6F7171">
                {subTitle}
              </Micro>
            </div>
          ) : (
            ''
          )}
        </div>
        <div className="width40 displayInlineFlex positionRelative">
          <div className={`${spacingStyle} onlyBottomPad textAlignRight width75`} aria-label={ariaLabelRight}>
            <TagName
              primitive="p"
              size={className === 'headerStyle' ? 'small' : type !== 'mobile' && type !== 'mfapp' && className === 'normalStyle' ? 'large' : 'small'}
              color={promoDiscount ? '#008331' : 'inherit'}
            >
              {rightValueText}
            </TagName>
          </div>
          <div className="width25 textAlignRight " style={{ position: 'absolute', right: '0', top: '-10px' }}>
            {showIcon && (
              <div style={{ marginLeft: !(isMVA() || isMobile()) && '0.875rem' }}>
                <ButtonIcon
                  data-analyticstrack="5G-expandedMyCart"
                  data-testid="miniCartToggleButton"
                  ariaLabel="Due Today Show details"
                  aria-expanded={!!isCartVisible}
                  renderIcon={() => <Icon name={getButtonIconName(isCartVisible)} color="#000000" size={isMobileview ? 'small' : 'large'} />}
                  onKeyDown={handleKeyDown}
                  onClick={handleClick}
                />
              </div>
            )}
          </div>
        </div>
      </Row>
    </div>
  );
};

export default CommonSection;

CommonSection.propTypes = {
  leftValueText: PropTypes.string,
  rightValueText: PropTypes.string,
  subTitle: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  id: PropTypes.string,
  ariaLabelRight: PropTypes.string,
  ariaLabelLeft: PropTypes.string,
  className: PropTypes.string,
  showIcon: PropTypes.bool,
  toggleCart: PropTypes.func,
  isCartVisible: PropTypes.bool,
  promoDiscount: PropTypes.string,
};

export const filterProducts = (item, plansReferenceData, EUPdata) => {
  console.log('call this method--- ');
  const planInfo = getProductRefData(item.sorId, item.productId, plansReferenceData);
  let EUPDetails = {};
  let equipmentUpgradeTitle = '';
  let equipmentUpgradeValue = '';
  let mtnValue = '';
  if (getLTEUpgrade()) {
    EUPDetails = EUPdata || null;
    equipmentUpgradeTitle = EUPDetails && EUPDetails.EquipmentUpgradeTitle ? EUPDetails.EquipmentUpgradeTitle : '';
    equipmentUpgradeValue = EUPDetails && EUPDetails.EquipmentUpgradeValue ? EUPDetails.EquipmentUpgradeValue : '';
    mtnValue = EUPDetails && EUPDetails.MTNValue ? EUPDetails.MTNValue : '';
  }

  return { planInfo, equipmentUpgradeTitle, equipmentUpgradeValue, mtnValue };
};

export const getButtonIconName = (isCartOpen) => (isCartOpen ? 'up-caret' : 'down-caret');
